module.exports = __webpack_public_path__ + "img/Flag_of_Cuba.6531cb1a.svg";